import { get } from 'lodash';
import { safeJsonParse } from '@td/practice_management_js';
import getClientInstance from '../../../app/config/apollo-client';
import CAN_DISPLAY_INITIATE_REFERRAL_BUTTON_QUERY from './queries/can-display-initiate-referral-button-query.js';

const canDisplayInitiateReferralButton = (memberId)  => {
  const apolloClient = getClientInstance();

  const promise =
    apolloClient.query({
      variables: { memberId: parseInt(memberId) },
      query: CAN_DISPLAY_INITIATE_REFERRAL_BUTTON_QUERY
    })
    .then(response  => {
      const status = get(safeJsonParse(get(response, "data.member.canDisplayInitiateReferralButton")), 'status');

      return status;
    })

  return promise;
};

export default canDisplayInitiateReferralButton;
